import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Hockey.es.js";
const e = o.forwardRef((c, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...c, weights: a }));
e.displayName = "HockeyIcon";
const n = e;
export {
  n as Hockey,
  e as HockeyIcon
};
